import { Button, Form, Input } from 'antd';
import Password from 'antd/lib/input/Password';
import React, { useState } from 'react';
import BoxError from '../components/BoxError';
import FormProps from '../interfaces/FormProps';
import { Result } from '../interfaces/Result';
import { useApp } from '../providers/AppProvider';
import { AiOutlineLogin } from 'react-icons/ai';


const AuthAdminForm: React.FC<FormProps> = ({
	onSuccess
}) => {


	const app = useApp();

	const [loading, setLoading] = useState(false);	
	const [error, setError] = useState<Result | null>(null);


	const submit = async (dados: any) => {
		
		setLoading(true);
		setError(null);
		let result: Result | null = await app.ajaxApi("post", "auth/admin", dados, false);
		
		if (result?.code !== 200) {
			setError(result);
			setLoading(false);
			return;
		}
		
		let data: any = result.dados;

		app.authAdmin(data.email, data.nome, data.token);		
		setLoading(false);

		if (onSuccess)
			onSuccess(result);
	}


	return (
		<>
			<BoxError result={error} />

			<Form layout='vertical' onFinish={submit}>
				<Form.Item label="E-mail" name="email" rules={[
					{ required: true, message: "Informe o e-mail" }
				]}>
					<Input autoFocus autoComplete='off' autoSave='off' />
				</Form.Item>

				<Form.Item label="Senha" name="senha" rules={[
					{ required: true, message: "Informe a senha" }
				]}>
					<Password autoComplete='off' autoSave='off' />
				</Form.Item>

				<div className="acoes">
					<Button htmlType='submit' type='primary' icon={<AiOutlineLogin />} loading={loading}>Entrar</Button>				
				</div>				
			</Form>
		</>
	);
}

export default AuthAdminForm;